import React from 'react'
import {observer} from 'mobx-react-lite'
import {useProfileStore} from '../profile-store'
import {FormPopup} from './form-popup'
import {RequestCreatedPopup} from './request-created-popup'

export const EmailChangePopup = observer(() => {
  const [state] = useProfileStore()

  switch (state.changeEmailPopupState) {
    case 'form':
      return <FormPopup />
    case 'request-created':
      return <RequestCreatedPopup />
    default:
      return null
  }
})
